export default __webpack_public_path__ + "static/media/close-icon2.28913a00.svg";